// extracted by mini-css-extract-plugin
export default {"canvas":"styles_canvas__1kC5S"};